import { ViewController } from '@estee/elc-service';
import { action, observable } from 'mobx';
import { DeliveryMethodsViewController } from '~controllers/DeliveryMethodsViewController';

export class EditDeliveryModalViewController extends ViewController {
    @observable public isOpen: boolean;
    deliveryMethodsCtrl: DeliveryMethodsViewController;
    @observable isClosingLoading = false;
    isLoading = false;

    constructor(deliveryMethodsCtrl: DeliveryMethodsViewController) {
        super();
        this.deliveryMethodsCtrl = deliveryMethodsCtrl;
    }

    @action
    public openModal = () => {
        this.isOpen = true;
    };

    @action
    public progCloseModal = async () => {
        this.isOpen = false;
    };
}
